const Login = () => import('./../views/Login.vue')

export default [
  { name: 'login', path: '/login', component: Login, meta: { acl: false } }
]
